import Vue from 'vue'
import Vuex from 'vuex'
import List from '../components/List.vue';
import axios from "axios";
import VueCookies from 'vue-cookies'
import Storage from 'vue-ls';
import Notifications from 'vue-notification'
import vSelect from 'vue-select'
import Router from "../components/Router.vue";
import 'vue-select/dist/vue-select.css';

require('../css/catalog.css');

Vue.config.productionTip = false

Vue.use(Vuex);
Vue.use(VueCookies);
Vue.use(Storage, {
    namespace: 'igr_',
    name: 'ls',
    storage: 'local',
});
Vue.use(Notifications);

Vue.component('v-select', vSelect)

const router = Router;

const store = new Vuex.Store({
    state: {
        page: {
            filter: {},
            cnt: 0,
        },
        settings: {
            url: '',
            id: 0,
            name: '',
            page: {
                current: 1,
                perPage: 20,
            },
            sort: {
                field: null,
                direction: null
            },
            filter: {
                filters: {
                    priceMax: 0,
                    priceMin: 0
                },
                isTransitStorage: false,
                search: ''
            },
        }
    },
    mutations: {
        updatePage(state, page) {
            state.page = page;
        },
        setSettings(state, settings) {
            state.settings = settings;
        },
    },
    actions: {
        UPDATE_STORE: (context, payload) => {
            axios.post(
                '/ajax/getPage.php',
                {
                    'route': context.state.settings.route,
                    'page': context.state.settings.page,
                    'sort': context.state.settings.sort,
                    'filter': context.state.settings.filter,
                    'isSmartFilter': payload
                },
                {
                    headers: {
                        'content-type': 'application/json; charset=utf8'
                    }
                }
            )
                .then(function (response) {
                    context.commit("updatePage", response.data);
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        SET_SETTINGS: (context, payload) => {
            payload = {
                id: payload.id ? parseInt(payload.id) : context.state.settings.id,
                route: payload.route ? payload.route : context.state.settings.route,
                page: payload.page ? payload.page : context.state.settings.page,
                sort: payload.sort ? payload.sort : context.state.settings.sort,
                filter: payload.filter ? payload.filter : context.state.settings.filter,
            };
            context.commit("setSettings", payload)
        }
    },
    getters: {
        page: state => state.page,
        filter: state => state.filter,
        settings: state => state.settings
    }
})

new Vue({
    router,
    store,
    render: function (h) {
        return h(List);
    },
    el: '#app',
    data: {

    },
    components: {
        List
    },
    created() {
        this.$cookies.config('30d');

        const regex = /\/catalog\/(?<catalogId>[0-9]+)\//;
        let m;
        if ((m = regex.exec(this.$route.path)) !== null && m.groups.catalogId > 0)
            this.$store.dispatch('SET_SETTINGS', {id: m.groups.catalogId});

        if (('transit' in this.$route.query && this.$route.query.transit == 'Y') || $cookies.get("showTransitStorage")) {
            this.$store.dispatch('SET_SETTINGS', {
                filter: {
                    isTransitStorage: true,
                }
            });
        }

        if ('khitprodazh' in this.$route.query && this.$route.query.khitprodazh == '1') {
            this.$store.dispatch('SET_SETTINGS', {
                filter: {
                    filters: {
                        khitprodazh: true,
                    },
                }
            });
        }

        if ('novinki' in this.$route.query && this.$route.query.novinki == '1') {
            this.$store.dispatch('SET_SETTINGS', {
                filter: {
                    filters: {
                        novinki: true,
                    },
                }
            });
        }

        if ($cookies.get("perPage")) {
            let perPage = $cookies.get("perPage")
            this.$store.dispatch('SET_SETTINGS', {page: {current: 1, perPage: perPage}});
        }


        let searchPages = ['/search/', '/search_archive/', '/sets/'];
        let sort = $cookies.get("sort");

        if (sort) {
            if(sort && sort.field == 'search' && !searchPages.includes(this.$route.path)){
                sort = {
                    field: 'id',
                    direction: 'desc'
                };
            }
            this.$store.dispatch('SET_SETTINGS', {sort: sort});
        }else if(!sort && searchPages.includes(this.$route.path)){
            sort = {
                field: 'search',
                direction: 'asc'
            };
            this.$store.dispatch('SET_SETTINGS', {sort: sort});
        }

        this.$store.dispatch('SET_SETTINGS', {route: {
                path: this.$route.path,
                query: this.$route.query,
            }});

        this.$store.dispatch('UPDATE_STORE', true);
    },
});